// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A dataflow's categories as chips. The chip itself matches the catalog
   cards' \`.tag\` (CatalogBrowseLayout.module.css) so a category reads the same
   on a card, in the drawer and under the canvas title. */

.ioZm0WqmXTo2X2QtcxUm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  font-family: var(--curio-font-family);
}

.d9Bmy2ngzcwteoDDhzns {
  height: 20px;
  border-radius: 10px;
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
  padding: 0 8px;
  font-size: var(--curio-font-size-xs);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* Read off the nodes, so they are not removable: filled, no border. The
   dataflow grey reads as a chip on the canvas and on a white dialog alike. */
.vjOhSshf0ds9jk_6YUEt {
  background: var(--curio-kind-dataflow-bg);
}

/* Set by hand: outlined, with a remove button. */
._3kW9fapnqAiW91OgGnH {
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border-strong);
}

.zbzp0D8LkY2IrnThJqyi {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  color: var(--curio-text-muted);
  font-size: var(--curio-font-size-sm);
  line-height: 1;
  cursor: pointer;
}

.zbzp0D8LkY2IrnThJqyi:hover {
  color: var(--curio-text-primary);
}

.DHkbXhbYCG58hpQt_hLu,
.l9gjavEan2INmUdWNYho {
  height: 20px;
  border-radius: 10px;
  border: 1px dashed var(--curio-border-strong);
  background: none;
  color: var(--curio-text-secondary);
  padding: 0 8px;
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  cursor: pointer;
  white-space: nowrap;
}

.DHkbXhbYCG58hpQt_hLu {
  border-style: solid;
}

.DHkbXhbYCG58hpQt_hLu:hover,
.l9gjavEan2INmUdWNYho:hover {
  color: var(--curio-text-primary);
  border-color: var(--curio-text-secondary);
}

.y91V2yz05bQW0pLHW1N3 {
  position: relative;
  display: inline-flex;
}

.kNRTJJ8TUhXBpG_YtLBz {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 8px;
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-modal);
  white-space: nowrap;
}

/* The dialog's form: always open, in the flow under the chips. */
.rjOlWQq72V0NITzbjl9q {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rNIumtNg2R7EO3uuB4Rn {
  display: flex;
  gap: 6px;
  align-items: center;
}

.VBXUWR4xRrf6ZEPj5NWA,
.cUo2Cs0CCJjBPXrZhKC0 {
  height: 28px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-primary);
  background: var(--curio-card-bg);
}

.VBXUWR4xRrf6ZEPj5NWA {
  padding: 0 4px;
}

.cUo2Cs0CCJjBPXrZhKC0 {
  width: 180px;
  padding: 0 8px;
}

.o_me2tbnE3geZGjwdvkG {
  height: 28px;
  border: none;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  padding: 0 12px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  cursor: pointer;
}

.o_me2tbnE3geZGjwdvkG:hover {
  background: var(--curio-top-bar-bg-hover);
}

.o_me2tbnE3geZGjwdvkG:disabled {
  opacity: 0.5;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/projects/DataflowCategoryInput.module.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;6EAC6E;AAC7E;EACE,yCAAyC;AAC3C;;AAEA,iDAAiD;AACjD;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,4CAA4C;EAC5C,qCAAqC;EACrC,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* A dataflow's categories as chips. The chip itself matches the catalog\n   cards' `.tag` (CatalogBrowseLayout.module.css) so a category reads the same\n   on a card, in the drawer and under the canvas title. */\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n  font-family: var(--curio-font-family);\n}\n\n.chip {\n  height: 20px;\n  border-radius: 10px;\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n  padding: 0 8px;\n  font-size: var(--curio-font-size-xs);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n/* Read off the nodes, so they are not removable: filled, no border. The\n   dataflow grey reads as a chip on the canvas and on a white dialog alike. */\n.chipAuto {\n  background: var(--curio-kind-dataflow-bg);\n}\n\n/* Set by hand: outlined, with a remove button. */\n.chipHand {\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border-strong);\n}\n\n.remove {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  color: var(--curio-text-muted);\n  font-size: var(--curio-font-size-sm);\n  line-height: 1;\n  cursor: pointer;\n}\n\n.remove:hover {\n  color: var(--curio-text-primary);\n}\n\n.more,\n.add {\n  height: 20px;\n  border-radius: 10px;\n  border: 1px dashed var(--curio-border-strong);\n  background: none;\n  color: var(--curio-text-secondary);\n  padding: 0 8px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.more {\n  border-style: solid;\n}\n\n.more:hover,\n.add:hover {\n  color: var(--curio-text-primary);\n  border-color: var(--curio-text-secondary);\n}\n\n.addWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.form {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  padding: 8px;\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-modal);\n  white-space: nowrap;\n}\n\n/* The dialog's form: always open, in the flow under the chips. */\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.formInline {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.select,\n.input {\n  height: 28px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-primary);\n  background: var(--curio-card-bg);\n}\n\n.select {\n  padding: 0 4px;\n}\n\n.input {\n  width: 180px;\n  padding: 0 8px;\n}\n\n.confirm {\n  height: 28px;\n  border: none;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  cursor: pointer;\n}\n\n.confirm:hover {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.confirm:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `ioZm0WqmXTo2X2QtcxUm`,
	"chip": `d9Bmy2ngzcwteoDDhzns`,
	"chipAuto": `vjOhSshf0ds9jk_6YUEt`,
	"chipHand": `_3kW9fapnqAiW91OgGnH`,
	"remove": `zbzp0D8LkY2IrnThJqyi`,
	"more": `DHkbXhbYCG58hpQt_hLu`,
	"add": `l9gjavEan2INmUdWNYho`,
	"addWrap": `y91V2yz05bQW0pLHW1N3`,
	"form": `kNRTJJ8TUhXBpG_YtLBz`,
	"stack": `rjOlWQq72V0NITzbjl9q`,
	"formInline": `rNIumtNg2R7EO3uuB4Rn`,
	"select": `VBXUWR4xRrf6ZEPj5NWA`,
	"input": `cUo2Cs0CCJjBPXrZhKC0`,
	"confirm": `o_me2tbnE3geZGjwdvkG`
};
export default ___CSS_LOADER_EXPORT___;
